import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  DoCheck,
  Inject,
  Input,
  KeyValueDiffers,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import {  isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn, fadeOut } from './carousel.animations';
import { MySlide } from '../../../models/business-objects';
import { Subscription, timer } from 'rxjs';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import {SafeHtmlPipe} from '../../shared/pipes/safeHtml.pipe';
import {SafeUrlPipe} from '../../shared/pipes/safeUrl.pipe';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    TranslateModule,
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    LocalizeRouterModule,
    SafeHtmlPipe,
    SafeUrlPipe
  ],
  animations: [
    trigger('carouselAnimation', [
      transition('void => *', [useAnimation(fadeIn, {params: { time: '1300ms' }})]),
      transition('* => void', [useAnimation(fadeOut, {params: { time: '1300ms' }})])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselComponent implements OnInit, DoCheck, AfterViewInit, OnDestroy {
  @Input() slides: MySlide[];
  @Input() slideHeight: string = 'auto';
  @Input() offsetControl: number;
  @Input() verticalControl = '';
  @Input() autoSlideIntervalInSec: number;
  showSpinner = false;
  differ: any;
  private timerSubscription: Subscription;
  currentSlide = 0;
  isCarouselReady = false;

  constructor(
    private renderer2: Renderer2,
    differs: KeyValueDiffers,
    @Inject(PLATFORM_ID) private platformId: any,
    private cdr: ChangeDetectorRef
  ) {
    this.differ = differs.find([]).create();
  }

  ngDoCheck() {
    const changes = this.differ.diff(this.slides);
    if (changes) {
      console.log('this.slides change detected');
    }
  }

  ngOnInit(): void {
    if (!this.offsetControl) { this.offsetControl = 0; }
    if (this.autoSlideIntervalInSec == null) { this.autoSlideIntervalInSec = 5; }
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  public ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.autoSlideIntervalInSec > 0) {
        this.timerSubscription = timer(this.autoSlideIntervalInSec * 1000, this.autoSlideIntervalInSec * 1000)
          .subscribe(() => {
            const next = this.currentSlide + 1;
            this.currentSlide = next === this.slides.length ? 0 : next;
            this.cdr.detectChanges();
          });
      }
    }
  }

  onPreviousClick() {
    const previous = this.currentSlide - 1;
    this.currentSlide = previous < 0 ? this.slides.length - 1 : previous;
    console.log('previous clicked, new current slide is: ');
    console.log(this.slides[this.currentSlide]);
  }

  onNextClick() {
    const next = this.currentSlide + 1;
    this.currentSlide = next === this.slides.length ? 0 : next;
    console.log('next clicked, new current slide is: ');
    console.log(this.slides[this.currentSlide]);
  }

  delay(ms: number) {
    if (ms == null || ms === 0) { ms = 2; }
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getSlideHeight(): string {
    if (this.slides && this.slides.length > 0) {
      const image = new Image();
      image.src = this.slides[0].src;
      if (image.height > 0) {
        return `${image.height}px`;
      }
    }
    return 'auto';
  }
}
